/* Header: metamorfosis en el home (tres etapas discretas) y subrenglon de
   envio gratis pasado el hero. Las transiciones viven en el CSS de cada
   pieza, asi los delays son transition-delay reales y la vuelta hacia arriba
   re-anima sola. */
const { mount, reduced } = window.EQ;

mount('[data-eq-header]', (el) => {
  const morph = el.dataset.morph === 'true';
  const chroma = el.dataset.chroma !== 'false' && !reduced();
  const HOLD = 200;
  let raw = 0, holdUntil = 0, avanzar = false, gestos = 0, tScroll = 0, holdGesto = 0, holdTimer = 0;
  // con el buscador enfocado el header queda compacto: si volvia arriba, la
  // etapa 0 escondia el campo con el texto a medio escribir (auditoria paso 5)
  let buscando = false;

  const pos = () => {
    const de = document.scrollingElement || document.documentElement;
    return de.scrollTop || window.scrollY || 0;
  };

  const paint = () => {
    let e = raw;
    // La etapa 1 es un TRANSITO con duracion, no un rango de scroll.
    if (e === 1 && avanzar) e = 2;
    if (e === 2 && Date.now() < holdUntil) e = 1;
    if (buscando) e = 2;
    if (morph) {
      el.classList.toggle('eq-header--e1', e === 1 && chroma);
      el.classList.toggle('eq-header--e2', e === 2);
    }
    // el subrenglon de envio solo pasado el hero (o siempre en internas)
    el.classList.toggle('eq-header--sub-on', morph ? e === 2 : true);
  };

  const onScroll = () => {
    const y = pos();
    const now = Date.now();
    if (now - tScroll > 120) gestos++;
    tScroll = now;
    const r = y < 30 ? 0 : (y < 190 ? 1 : 2);
    if (raw === 0 && r >= 1 && !reduced()) {
      holdUntil = now + HOLD;
      holdGesto = gestos;
      clearTimeout(holdTimer);
      holdTimer = setTimeout(() => { avanzar = true; paint(); }, HOLD + 20);
    }
    // segundo empujon: el conteo se corta y la etapa 2 entra de una
    if (holdUntil && gestos > holdGesto) { holdUntil = 0; avanzar = true; clearTimeout(holdTimer); }
    if (r === 0) { holdUntil = 0; avanzar = false; clearTimeout(holdTimer); }
    raw = r;
    paint();
  };

  window.addEventListener('scroll', onScroll, { passive: true });
  const buscador = el.querySelector('.eq-header__search');
  const onFocusIn = () => { buscando = true; paint(); };
  const onFocusOut = () => { buscando = false; paint(); };
  if (buscador) { buscador.addEventListener('focusin', onFocusIn); buscador.addEventListener('focusout', onFocusOut); }
  raw = pos() < 30 ? 0 : (pos() < 190 ? 1 : 2);
  if (raw === 2) avanzar = true;
  // Si la pagina ya arranca scrolleada (vuelta a la compactera, scroll
  // restaurado), el estado se aplica SIN transicion: la metamorfosis es para
  // el gesto de scrollear, no para aparecer en la mitad de la pagina.
  if (raw !== 0) {
    el.classList.add('eq-header--quieto');
    paint();
    void el.offsetWidth;
    requestAnimationFrame(() => requestAnimationFrame(() => el.classList.remove('eq-header--quieto')));
  } else paint();

  return () => {
    window.removeEventListener('scroll', onScroll); clearTimeout(holdTimer);
    if (buscador) { buscador.removeEventListener('focusin', onFocusIn); buscador.removeEventListener('focusout', onFocusOut); }
  };
});
